import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { sortBy } from 'lodash/fp';
import parse from 'html-react-parser';
import { withTheme } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { EventTrackingMethodType } from '../../interfaces/EventType';

const ProgramsLabel = withTheme(styled(Typography)`
  font-size: 13px;
  margin-top: 15px;
  ${({ theme: { breakpoints } }) => `${breakpoints.down('sm')} {
    font-size: 11px;
    margin-top: 10px;
  }`};
  > span {
    &:not(:last-child):after {
      content: ', ';
    }
    &.matched {
      font-weight: 600;
    }
    &.matched.ineligible {
      color: ${({ theme: { palette } }) => palette.error.light};
      text-decoration: line-through;
    }
  }
`);

const programLabelClass = (isMatch, isGuestEligible) => {
  const matchClass = isMatch ? 'matched' : '';
  const ineligibleClass = !isGuestEligible ? 'ineligible' : '';

  return `${matchClass} ${ineligibleClass}`;
};

const EventPrograms = ({ data, ...props }) => {
  const sortedPrograms = sortBy('label', data);
  return (
    <ProgramsLabel {...props}>
      {sortedPrograms.map(
        ({ label, isMatch = false, isGuestEligible = true }) => (
          <span
            key={label}
            className={programLabelClass(isMatch, isGuestEligible)}
          >
            {parse(label)}
          </span>
        )
      )}
    </ProgramsLabel>
  );
};

EventPrograms.propTypes = {
  data: PropTypes.arrayOf(EventTrackingMethodType).isRequired
};

export default EventPrograms;
